import { getEnvVariable } from "../../modules/environmentalList";

export const ExternalList = {
    MPS: {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#00bfa5'
                    }
                },
                {
                    "type": "menu",
                    "title": "My Dashboards",
                    "icon": "fa fa-cogs",
                    "materialicon": "dashboard",
                    "link": "/userdashboardflows",
                    "key": "userdashboardflows",
                    "style": {
                        'color': '#00a152'
                    }
                }, 
            ],
            "myportallist":
                [
                // {
                //     "type": "menu",
                //     "title": "Classic Search",
                //     "icon": "search",
                //     "materialicon": "search",
                //     "link": "/search",
                //     "key": "Search",
                //     "style": {
                //         'color': '#61A5DC'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "Search",
                //     "icon": "find_in_page",
                //     "materialicon": "find_in_page",
                //     "link": "/advsearch",
                //     "key": "Search",
                //     "style": {
                //         'color': '#e65100'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Process Flows",
                    "icon": "fa fa-cogs",
                    "materialicon": "schema",
                    "link": "/userprocessflows",
                    "key": "userprocessflows",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Administration/applications",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },               
                // {
                //     "type": "menu",
                //     "title": "Contacts",
                //     "key": "contacts",
                //     "link": "#/Administration/externalcontacts",
                //     "icon": "fa fa-user-circle-o",
                //     "materialicon": "contacts",
                //     "style": {
                //         'color': '#006064'
                //     }
                // }
            ],
            "publichublist":
            [
                {
                    "type": "menu",
                    "title": "User Approvals",
                    "icon": "assignment_turned_in",
                    "materialicon": "assignment_turned_in",
                    "link": "#/Portal/Approvals",
                    "key": "Search",
                    "style": {
                        'color': '#1b5e20'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Users",
                //     "icon": "fa fa-users",
                //     "link": "#/users",
                //     "key": "usersform",
                //     "materialicon": "person",
                //     "style": {
                //         'color': '#01579b'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Company",
                    "icon": "fa fa-users",
                    "link": "/Company",
                    "key": "Companyform",
                    "materialicon": "business",
                    "style": {
                        'color': '#795548'
                    }
                }
            ],
    },
 
}

